import { combineReducers } from "redux";

import authReducer from "./features/auth/auth";
import userReducer from "./features/user/user";
import membershipReducer from "./features/memberhsip/membership";
import organizationReducer from "./features/organization/organization";

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  membership: membershipReducer,
  organization: organizationReducer,
});
